<template>
    <article
        class="flex min-h-[429px] w-full grow flex-col justify-center rounded-2xl bg-white dark:bg-surface-card shadow-[-8px_-4px_60px_rgba(152,149,171,0.25)]"
    >
        <div class="flex w-full flex-1 flex-col justify-between px-12 py-14 max-md:max-w-full max-md:px-5">
            <h3 class="text-slate-900 dark:text-txt-headings flex w-full pb-4 text-2xl font-semibold leading-8 max-md:max-w-full">
                <span class="min-w-[320px] pr-9 max-md:max-w-full">"{{ quote }}"</span>
            </h3>
            <p class="text-neutral-400 dark:text-txt-body mt-6 min-h-[108px] w-full text-base leading-6 max-md:max-w-full">
                {{ description }}
            </p>
            <footer class="mt-6 flex w-full pt-4 max-md:max-w-full">
                <img
                    :alt="name"
                    class="aspect-square w-[71px] max-w-[710px] shrink-0 self-start rounded-[14790px] object-contain"
                    :src="image"
                />
                <div class="flex flex-col items-start justify-center pl-4">
                    <p class="text-base text-[#282828]">{{ name }}</p>
                    <p class="text-neutral-400 dark:text-txt-body whitespace-nowrap text-lg leading-none">{{ role }}</p>
                </div>
            </footer>
        </div>
    </article>
</template>

<script setup lang="ts">
export interface TestimonialProps {
    quote: string
    description: string
    name: string
    role: string
    image: string
}

defineProps({
    quote: {
        type: String,
        default: ''
    },
    description: {
        type: String,
        default: ''
    },
    name: {
        type: String,
        default: ''
    },
    image: {
        type: String,
        default: ''
    },
    role: {
        type: String,
        default: ''
    }
})
</script>
